module.exports = __webpack_public_path__ + "img/case_top_bg.d735dc3b.png";